import { useRouter } from 'next/router';

import { useCommunityContext } from 'components/CommunityContext';
import { useUsersSearch } from 'components/new/hooks/useUsersSearch';

import { USERS_QUERY } from 'schema/User/queries';

import { Mention, mapUserObject } from './helpers';

export const useMentionSearch = (): {
  handleSearch: (search: string, spaceId?: string) => Promise<Mention[]>;
} => {
  const { community } = useCommunityContext();
  const router = useRouter();
  const spaceId = router?.query?.spaceId as string | undefined;

  // Call the general useUsersSearch hook with explicit values for mentions
  const { handleSearch } = useUsersSearch<Mention>(
    USERS_QUERY, // query
    false, // isUnifiedQuery
    mapUserObject, // mapFunction
    'community.mentionableUsers.edges', // dataPath
    { communityId: community.id, ...(spaceId && { spaceId }) } // initialVariables
  );

  return {
    handleSearch: (search: string, overrideSpaceId?: string) => {
      const additionalVariables = overrideSpaceId
        ? { communityId: community.id, spaceId: overrideSpaceId }
        : undefined;
      return handleSearch(search, additionalVariables);
    },
  };
};
